import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { AuthApi, ClinicsApi } from '../../api/client';
import { ROUTES } from '../../constants';
import { RequestDynamicLinkData } from '../../models';
import { Clinic } from '../../shared/types';
import View from './View';

const Container: React.FC = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { data: clinics, isLoading: isFetchingClinics } = useQuery<Clinic[]>(
    'CLINICS',
    ClinicsApi.fetchClinics,
    {
      onError: (err) => {
        console.log(err);
      },
    }
  );

  const login = () => {
    history.push(ROUTES.LOGIN);
  };

  const handelRequestDynamicLink = (email: string, clinic: Clinic) => {
    requestDynamicLink.mutate({ email, clinicId: clinic.id });
  };

  const requestDynamicLink = useMutation(
    (data: RequestDynamicLinkData) => AuthApi.requestDynamicLink(data),
    {
      onSuccess: (_, { email, clinicId }) => {
        history.push(ROUTES.DYNAMIC_LINK_SENT, {
          email,
          clinic: clinics && clinics.find((clinic) => clinic.id === clinicId),
        });
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  useEffect(() => {
    setIsLoading(isFetchingClinics || requestDynamicLink.isLoading);
  }, [isFetchingClinics, requestDynamicLink]);

  return (
    <View
      isLoading={isLoading}
      clinics={clinics}
      login={login}
      requestDynamicLink={handelRequestDynamicLink}
    />
  );
};

export default Container;
